import { Observable, map, throwError } from 'rxjs';
import { RequestChange } from 'src/app/models/request-change';
import { Setor } from 'src/app/models/setor';
import { Turno } from 'src/app/models/turno';
import { ScaleStore } from '../scale.store';
import { ScaleInUseService } from '../scale-in-use.service';
import {
  ItemColaborador,
  ItemColaboradorDTO,
} from 'src/app/models/itens_colaboradores';
import {
  addColaborador,
  addColaboradorDTO,
} from 'src/app/models/add-colaborador';
import {
  SolicitacaoTroca,
  Solicitacoes,
} from 'src/app/models/solicitacao-troca';

export abstract class TurnoService {
  protected scaleStore: ScaleStore;
  protected scaleInUse: ScaleInUseService;

  constructor(scaleStore: ScaleStore, scaleInUse: ScaleInUseService) {
    this.scaleStore = scaleStore;
    this.scaleInUse = scaleInUse;
  }

  protected handleError(error: any) {
    return throwError(error);
  }

  protected log(message: string) {
    console.log('============= message response ============');
    console.log(message);
  }

  public abstract carregaTurnos(escaldId: number): Observable<Turno[]>;
  public abstract criaTurno(turno: Turno): Observable<Turno>;
  public abstract atualizarTurno(
    turnoId: number,
    newTurno: Turno
  ): Observable<Turno>;
  public abstract filtrarTurno(turnoId: number): Observable<Turno>;
  public abstract deletarTurno(turnoId: number): void;

  public abstract carregaSetores(escaldId: number): Observable<Setor[]>;
  public abstract carregaSetoresEscalaPai(
    escaldId: number
  ): Observable<Setor[]>;
  public abstract carregaSetorPorEscala(
    escalaId: number,
    setorId: number
  ): Observable<Setor>;
  public abstract criaSetor(setor: Setor): Observable<Setor>;
  public abstract atualizarSetor(
    setorId: number,
    newSetor: Setor
  ): Observable<Setor>;
  public abstract filtrarSetor(setorId: number): Observable<Setor>;
  public abstract deletarSetor(setorId: number): void;

  public abstract criaSolicitacaoTroca(
    solicitacao: RequestChange
  ): Observable<RequestChange>;
  public abstract carregarSolicitacoesTroca(
    escalaId: number
  ): Observable<Solicitacoes>;
  public abstract recusarSolicitacaoTroca(
    solicitacaoId: string
  ): Observable<any>;
  public abstract aprovarSolicitacaoTroca(
    solicitacaoId: string
  ): Observable<any>;

  public abstract atualizarItemColaborador(
    itemId: number,
    newItem: ItemColaboradorDTO
  ): Observable<ItemColaborador>;
  public abstract criaItemColaborador(
    item: ItemColaboradorDTO
  ): Observable<ItemColaborador>;
  public abstract deletarItemColaborador(itemId: number): void;
  public abstract deletarItensColaborador(itens: number[]): void;

  public abstract adicionarColaborador(
    colaboradorData: addColaboradorDTO
  ): Observable<addColaborador>;
  public abstract carregaSetoresPeriodo(
    escalaPeriodo: number
  ): Observable<Setor[]>;
  public abstract carregaTurnosPeriodo(
    escalaPeriodo: number
  ): Observable<Turno[]>;

  public getTurnos(): Observable<Turno[]> {
    return this.scaleInUse.turnos$;
  }

  public getSetores(): Observable<Setor[]> {
    return this.scaleInUse.setores$;
  }

  public getTurnoById(id: number): Observable<Turno> {
    return this.scaleInUse.turnos$.pipe(
      map((turnos) => {
        return turnos.find((turno) => turno.id === id) || ({} as Turno);
      })
    );
  }

  public getSetorById(id: number): Observable<Setor> {
    return this.scaleInUse.setores$.pipe(
      map((setor) => {
        return setor.find((setor) => setor.id === id) || ({} as Setor);
      })
    );
  }
}
